<template>
   <div style="padding-bottom:40px;">
     
    <div class="ui inverted  top attached menu" style="position:relative;z-index:100">
        <a href="/" class="item"><i class="home icon"></i>Home</a>
        <a  href="/about_database" class="item"></i>About the Database</a>
        <a  href="/about_project" class="item"></i>"Art for Display" Project</a>
        <a  href="/contact" class="item"></i>Contact</a>
        <div class="right menu">
             <div v-if="logged" class="ui dropdown icon item" id="library" v-on:click="$router.push({path:'/library'})">
              <div  :data-tooltip="tooltip('Library')" data-position='bottom center'> <i class="book icon"></i></div>
            </div>
            <div v-if="logged" class="ui dropdown icon item" id="plan" v-on:click="$router.push({path:'/plan'})">
                <div  :data-tooltip="tooltip('Plan')" data-position='bottom center'><i class="map outline icon"></i></div>
            </div>
            <div v-if="logged" class="ui dropdown icon item" id="3d" v-on:click="$router.push({path:'/visualisation3d'})">
                <div  :data-tooltip="tooltip('3D Visualisation')" data-position='bottom center'><i class="cubes icon"></i></div>
            </div>
            <div v-if="logged==true" class="ui dropdown icon item" id="download" >
                <div  :data-tooltip="tooltip('Downloads')" data-position='bottom center'><i class="download alternate icon"></i></div>
                 <div class="menu">
                   <!-- <div v-for="item in inventories" :key="item.name" class="link item">-->
                     <a v-for="item in inventories" :key="item.name" class="link item" v-bind:href="'api/downloads/'+item.name" download>{{item.label}}</a>
                   <!-- </div>-->
                </div>
            </div>
            <div v-if="logged==true && (role=='contributor' || role=='admin')" class="ui dropdown icon item" id="notesmenu"  v-on:click="$router.push({path:'/notes'})">
                <div  :data-tooltip="tooltip('Notes')" data-position='bottom center'><i class="pencil alternate icon"></i></div>
            </div>
            <div v-if="logged==true && (role=='contributor' || role=='admin'|| role=='user')" class="ui dropdown icon item" id="help"  v-on:click="$router.push({path:'/help'})">
                <div  :data-tooltip="tooltip('Help')" data-position='bottom center'><i class="question icon"></i></div>
            </div>
             
          
            
            
            <div v-if="logged==false" class="link icon item" v-on:click="showLoginModal()">
                <i class="user outline icon"></i>
            </div>
            <div v-if="logged==true" class="ui dropdown icon item" id="usermenu">

                <div :data-tooltip="tooltip('User')" data-position='bottom center'><i class="user icon"></i></div>
                <div class="menu">
                    <div class="item"  v-if="role=='user' || role=='contributor' || role=='admin'">
                        <router-link to="/settings" style="color:black">Settings</router-link>
                    </div>
                    <div class="item" v-if="role=='admin'">
                        <router-link to="/langenfels"  style="color:black">Administration</router-link>
                    </div>
                    <div class="item" v-on:click="logout()">Log out</div>
                </div>
            </div>
            <div v-if="logged==true" class="link item" v-on:click="$router.push({path:'/advancedsearch'})">
                <i class="search icon"></i>Scientific Search
            </div>
            <div v-if="logged && !searchPage" class="ui right aligned category search item">
                <div class="ui transparent icon input">
                    <input class="prompt" type="text" id="topsearch" placeholder="Quick search..." v-on:keyup.13="search()" style="color:white;">
                    <i class="search inverted link icon" v-on:click="search()"></i>
                </div>
                <div class="results"></div>
            </div>
        </div>
    </div>
     <div class="ui tiny attached menu"> 
     
       <div v-for="item in inventories" :key="item.name" class="link item" v-on:click="$router.push({ name: 'list', query: { inventory: item.name, page:1 }})" v-bind:class="{'active':(item.name==$route.query.inventory),'disabled':(item.name!='1621_Prague_B' && item.name!='1623_Briers_A' && !logged )}">
            <!--<router-link :to="{ name: 'list', query: { inventory: item.name }}" style="color:black">{{item.label}}</router-link>-->
            {{item.label}}
     </div>
       <!-- <div class="disabled item">
            2020 Prague
        </div>-->
        <div class="item">
           <a href="http://documenta.rudolphina.com" target="_blank">Documenta Rudolphina</a>
        </div>
     
    </div>
    <div class="ui modal" id="login" style="width:35%">
        <div class="header">User Login</div>
        <div class="ui middle aligned center aligned grid">
            <div class="column">
                <form class="ui large form" id="user_login">
                    <div class="ui segment" style="padding:30px">
                        <div class="field">
                            <div class="ui left icon input">
                                <i class="user icon"></i>
                                <input type="text" name="username" placeholder="Username" id="username">
                            </div>
                        </div>
                        <div class="field">
                            <div class="ui left icon input">
                                <i class="lock icon"></i>
                                <input type="password" name="password" placeholder="Password" id="password" v-on:keyup.13="login">
                            </div>
                        </div>
                        <div v-if="loginfailed" class="ui negative message">
                            Login failed.
                        </div><br><br>
                        <div class="ui large submit button" v-on:click="login">Login</div>
                    </div>
                </form>
            </div>
        </div>
    </div>

</div>


</template>

<script>
    export default {
        data() {
            return {
                searchPage: false,
                logged: false,
                role: "",
                loginfailed: false,
                inventories: "",
                showTooltip: true

            }
        },
        mounted() {

            if (this.$route.path.startsWith('/search')) {
                this.searchPage = true;
            }
            else {
                this.searchPage = false;
            }
            axios
                .get('/api/isauth/')
                .then(response => {
                    if (response.data.isauth) {
                        this.logged = true;
                        this.role = response.data.role;
                    }
                    else {
                        this.logged = false;

                    }
                })
            axios
                .get('/api/inventories')
                .then(response => {
                    this.inventories = response.data;
                })

        },
        methods: {
            tooltip: function(str) {
                if (this.showTooltip) return str;
            },
            search: function() {
                var search_query = $('#topsearch').val();
                this.$router.push({ name: 'advancedsearch', query: { search: search_query } });
            },

            login: function() {
                var myThis = this;
                var credentials = {};
                credentials.username = $('#username').val();
                credentials.password = $('#password').val();
                axios
                    .post('/api/login/', credentials)
                    .then(response => {
                        $('#login').modal('hide');
                        this.logged = true;
                        this.role = response.data.role;
                        if (this.$route.params.hasOwnProperty('page')) {
                            this.$router.push({ path: this.$route.params.page });
                        }

                    }).catch(function(error) {
                        $('#login').transition({
                            animation: 'shake',
                            duration: 700,
                        })
                        myThis.loginfailed = true;
                        $('#password').val("");

                        // $('#login').modal('hide');

                    });

            },
            logout: function() {
                this.logged = false;
                axios
                    .get('/api/logout/')
                    .then(response => {
                        this.$router.go();
                    })
            },
            showLoginModal: function() {

                $('#login').modal('show');

            }


        },
        watch: {
            $route(to, from) {
                //  console.log("route changed :"+to.name);
                if (to.name.startsWith('advancedsearch')) {
                    this.searchPage = true;
                    // console.log("swithcing of the search field")
                }
                else {
                    this.searchPage = false;
                }
            },
            logged: function(to, from) {
                if (to) {
                    setTimeout(function() {
                        $('#usermenu').dropdown();
                        $('#download').dropdown();
                    }, 100);
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hidden {
        display: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheTopMenu.vue